import computed from './computed'
import components from './components'
import resources from './resources'
import data from './data'
import methods from './methods'

export default {
  computed,
  components,
  data,
  methods,

  mixins: [resources]
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/index.js